export default class ActionCreateRequest {
    constructor(supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '<span></span>',
                pushMessage: '',
            };
        });

        this.coinsToEarn = null;
        this.activeFrom = null;
        this.activeTo = null;
        this.challengeType = null;
        this.activityType = null;
        this.measureUnit = null;
        this.relatedToCommuteWork = null;
        this.goalValue = null;
        this.action = null;
        this.sendPushWhenCompleted = true;
    }
}
